// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__128Px","footer":"ChangeClinic_footer__3i2md"};